// Updated by Elevate: 2026-01-02T23:26:28.996Z
// Safe Performance Optimizations - Prevent Layout Shifts
(function() {
  'use strict';

  // Add dimensions to images to prevent layout shifts
  function preventImageShifts() {
    const images = document.querySelectorAll('img:not([data-dims-set])');

    images.forEach(img => {
      // Mark as processed
      img.dataset.dimsSet = 'true';

      // If image already has natural dimensions, set them
      if (img.naturalWidth && img.naturalHeight) {
        if (!img.width) img.width = img.naturalWidth;
        if (!img.height) img.height = img.naturalHeight;

        // Add aspect ratio for modern browsers
        if (!img.style.aspectRatio) {
          img.style.aspectRatio = `${img.naturalWidth}/${img.naturalHeight}`;
        }
      } else {
        // Wait for image to load then set dimensions
        img.addEventListener('load', function() {
          if (!this.width && this.naturalWidth) {
            this.width = this.naturalWidth;
            this.height = this.naturalHeight;
          }
          if (!this.style.aspectRatio && this.naturalWidth) {
            this.style.aspectRatio = `${this.naturalWidth}/${this.naturalHeight}`;
          }
        });
      }

      // Set loading attribute for better performance
      const rect = img.getBoundingClientRect();
      const inViewport = rect.top < window.innerHeight && rect.bottom > 0;

      if (!img.loading) {
        if (inViewport) {
          img.loading = 'eager';
          // Priority for above-the-fold images
          if (rect.top < window.innerHeight / 2) {
            img.fetchpriority = 'high';
          }
        } else {
          img.loading = 'lazy';
        }
      }
    });
  }

  // Optimize Shopify responsive images
  function optimizeResponsiveImages() {
    const images = document.querySelectorAll('img[src*="cdn.shopify.com"]:not([srcset])');

    images.forEach(img => {
      if (!img.src || img.srcset) return;

      // Generate responsive srcset for Shopify images
      const src = img.src;
      const widths = [165, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];

      // Only create srcset for reasonably sized images
      if (img.width > 100 || img.naturalWidth > 100) {
        const srcset = widths
          .filter(w => w <= (img.naturalWidth || img.width || 2048) * 2)
          .map(w => {
            const url = src.replace(/(_\d+x\d*)?(\.\w+)(\?.*)?$/, `_${w}x$2$3`);
            return `${url} ${w}w`;
          })
          .join(', ');

        if (srcset) {
          img.srcset = srcset;
          img.sizes = img.sizes || '(min-width: 750px) 50vw, 100vw';
        }
      }
    });
  }

  // Stabilize header dimensions
  function stabilizeHeader() {
    const header = document.querySelector('.header');
    if (header && !header.style.minHeight) {
      const height = header.offsetHeight;
      if (height > 0) {
        header.style.minHeight = height + 'px';
      }
    }

    // Stabilize logo
    const logo = document.querySelector('.header__heading-logo');
    if (logo && logo.tagName === 'IMG') {
      if (!logo.width && logo.naturalWidth) {
        logo.width = logo.naturalWidth;
        logo.height = logo.naturalHeight;
      }
    }
  }

  // Initialize performance optimizations
  function init() {
    // Run immediately
    preventImageShifts();
    stabilizeHeader();

    // Run after DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        preventImageShifts();
        optimizeResponsiveImages();
        stabilizeHeader();
      });
    } else {
      optimizeResponsiveImages();
    }
  }

  // Start optimizations
  init();

  // Re-run when new content is added (for dynamic content)
  const observer = new MutationObserver(function(mutations) {
    // Debounce to avoid excessive processing
    if (observer.timeout) clearTimeout(observer.timeout);
    observer.timeout = setTimeout(function() {
      preventImageShifts();
      optimizeResponsiveImages();
    }, 100);
  });

  // Observe for dynamic content
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Expose for debugging
  window.SafePerformance = {
    preventImageShifts: preventImageShifts,
    optimizeResponsiveImages: optimizeResponsiveImages,
    stabilizeHeader: stabilizeHeader
  };
})();

/* TT Order Summary visual layer — read-only; does not change cart state */
(function () {
  'use strict';

  if (window.TTOrderSummaryVisual && window.TTOrderSummaryVisual.version === '1.0.0') return;

  var scheduled = false;
  var observer = null;

  function parseMoney(text) {
    var raw = String(text || '').replace(/\s/g, '').replace(/[^\d,.\-]/g, '');
    if (!raw) return 0;

    var comma = raw.lastIndexOf(',');
    var dot = raw.lastIndexOf('.');
    var decimal = Math.max(comma, dot);

    if (decimal >= 0) {
      var integerPart = raw.slice(0, decimal).replace(/[,.]/g, '');
      var decimalPart = raw.slice(decimal + 1).replace(/[,.]/g, '');
      raw = integerPart + '.' + decimalPart;
    } else {
      raw = raw.replace(/[,.]/g, '');
    }

    var value = Number(raw);
    return Number.isFinite(value) ? Math.round(value * 100) : 0;
  }

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat('pt-PT', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function itemReferenceTotal(drawer, currentTotal) {
    var reference = 0;
    var rows = drawer.querySelectorAll('.cart-drawer-item');

    rows.forEach(function (row) {
      var oldPrice = row.querySelector('.cart-item__old-price.compare-price');
      var currentPrice = row.querySelector('.regular-price');
      var freeBadge = row.querySelector('.cart-item__free-badge');

      var current = currentPrice ? parseMoney(currentPrice.textContent) : (freeBadge ? 0 : 0);
      var compare = oldPrice ? parseMoney(oldPrice.textContent) : current;

      reference += Math.max(compare, current);
    });

    return Math.max(reference, currentTotal);
  }

  function ensureStyles() {
    if (document.getElementById('tt-order-summary-visual-style')) return;

    var style = document.createElement('style');
    style.id = 'tt-order-summary-visual-style';
    style.textContent =
      'cart-drawer .tt-order-summary-visual{margin:18px 0 0;padding:16px 0 11px;border-top:1px solid rgba(26,47,39,.14);color:#1a2f27}' +
      'cart-drawer .tt-order-summary-visual__title{margin:0 0 10px;font-size:18px;line-height:1.2;font-weight:700;letter-spacing:-.02em;color:#1a2f27}' +
      'cart-drawer .tt-order-summary-visual__row{display:flex;align-items:baseline;justify-content:space-between;gap:16px;padding:3px 0;font-size:13px;line-height:1.4}' +
      'cart-drawer .tt-order-summary-visual__label{color:rgba(26,47,39,.68)}' +
      'cart-drawer .tt-order-summary-visual__value{font-weight:600;text-align:right;color:#1a2f27}' +
      'cart-drawer .tt-order-summary-visual__row--saving .tt-order-summary-visual__value{color:#2f8050}' +
      'cart-drawer .tt-order-summary-visual__row--saving[hidden]{display:none!important}' +
      'cart-drawer .tt-subtotal-price-wrap{display:flex;align-items:center;justify-content:flex-end;gap:7px;flex-wrap:wrap}' +
      'cart-drawer .tt-subtotal-saving-badge{display:inline-flex;align-items:center;justify-content:center;padding:4px 8px;border-radius:999px;background:#ffcc2e;color:#1a2f27;font-size:10px;line-height:1;font-weight:800;white-space:nowrap}' +
      'cart-drawer .tt-subtotal-reference{color:#999;font-size:14px;line-height:1;text-decoration:line-through;text-decoration-thickness:1px;white-space:nowrap}' +
      'cart-drawer .tt-subtotal-current{color:#1a2f27!important;font-size:20px!important;font-weight:800!important;white-space:nowrap}' +
      'cart-drawer .cart-drawer__totals{border-top:1px solid rgba(26,47,39,.14);padding-top:12px}' +
      'cart-drawer .cart-drawer__totals__row{margin:0!important;gap:10px!important}' +
      'cart-drawer .cart-drawer__totals__row>span:first-child{font-weight:700!important;color:#1a2f27!important}' +
      '@media(max-width:420px){cart-drawer .tt-order-summary-visual__title{font-size:17px}cart-drawer .tt-subtotal-price-wrap{gap:5px}cart-drawer .tt-subtotal-saving-badge{font-size:9px;padding:4px 7px}cart-drawer .tt-subtotal-reference{font-size:13px}cart-drawer .tt-subtotal-current{font-size:18px!important}}';

    document.head.appendChild(style);
  }

  function render() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.classList.contains('is-empty')) return;

    var nativeMoney = drawer.querySelector('.cart-drawer__totals__row__money');
    var nativeRow = drawer.querySelector('.cart-drawer__totals__row');
    var totals = drawer.querySelector('.cart-drawer__totals');
    if (!nativeMoney || !nativeRow || !totals) return;

    ensureStyles();

    var currentTotal = parseMoney(nativeMoney.textContent);
    var referenceTotal = itemReferenceTotal(drawer, currentTotal);
    var saving = Math.max(0, referenceTotal - currentTotal);
    var percentage = referenceTotal > 0 ? Math.round((saving * 100) / referenceTotal) : 0;
    var signature = [currentTotal, referenceTotal, saving, percentage].join(':');

    var summary = drawer.querySelector('.tt-order-summary-visual');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'tt-order-summary-visual';
      summary.innerHTML =
        '<h3 class="tt-order-summary-visual__title">Resumo da Encomenda</h3>' +
        '<div class="tt-order-summary-visual__row">' +
          '<span class="tt-order-summary-visual__label">Valor da oferta</span>' +
          '<span class="tt-order-summary-visual__value" data-tt-offer-value></span>' +
        '</div>' +
        '<div class="tt-order-summary-visual__row tt-order-summary-visual__row--saving" data-tt-saving-row>' +
          '<span class="tt-order-summary-visual__label">Poupança</span>' +
          '<span class="tt-order-summary-visual__value" data-tt-saving-value></span>' +
        '</div>' +
        '<div class="tt-order-summary-visual__row">' +
          '<span class="tt-order-summary-visual__label">Envio</span>' +
          '<span class="tt-order-summary-visual__value">Calculado no checkout</span>' +
        '</div>';

      var footer = totals.closest('.cart-drawer__footer') || totals.parentElement;
      footer.insertAdjacentElement('beforebegin', summary);
    }

    if (summary.dataset.ttSignature === signature && nativeRow.querySelector('.tt-subtotal-price-wrap')) return;
    summary.dataset.ttSignature = signature;

    var offerValue = summary.querySelector('[data-tt-offer-value]');
    var savingRow = summary.querySelector('[data-tt-saving-row]');
    var savingValue = summary.querySelector('[data-tt-saving-value]');

    if (offerValue) offerValue.textContent = money(referenceTotal);

    if (saving > 0) {
      if (savingRow) savingRow.hidden = false;
      if (savingValue) savingValue.textContent = '-' + money(saving);
    } else if (savingRow) {
      savingRow.hidden = true;
    }

    var right = nativeRow.querySelector(':scope > span:last-child');
    if (!right) return;

    right.innerHTML = '';
    var wrap = document.createElement('span');
    wrap.className = 'tt-subtotal-price-wrap';

    if (saving > 0 && percentage > 0) {
      var badge = document.createElement('span');
      badge.className = 'tt-subtotal-saving-badge';
      badge.textContent = percentage + '% POUPANÇA';
      wrap.appendChild(badge);

      var reference = document.createElement('s');
      reference.className = 'tt-subtotal-reference';
      reference.textContent = money(referenceTotal);
      wrap.appendChild(reference);
    }

    var current = document.createElement('strong');
    current.className = 'tt-subtotal-current cart-drawer__totals__row__money';
    current.textContent = money(currentTotal);
    wrap.appendChild(current);

    right.appendChild(wrap);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      render();
    });
  }

  function observe() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || observer) return;
    observer = new MutationObserver(schedule);
    observer.observe(drawer, { childList: true, subtree: true, characterData: true });
  }

  ['cart:updated', 'cart-update', 'cartQuantityUpdated', 'cart:refresh', 'cart:change', 'cart-drawer:updated'].forEach(function (eventName) {
    document.addEventListener(eventName, schedule);
  });

  window.TTOrderSummaryVisual = {
    version: '1.0.0',
    render: render
  };

  function init() {
    observe();
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();